import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import React from "react";
import Navbar from "./components/Navbar";
import LandingPage from "./pages/LandingPage";
import AboutPage from "./pages/AboutPage";
import ProjectsPage from "./pages/ProjectsPage";
import ContactPage from "./pages/ContactPage";
import NotFoundPage from "./pages/NotFoundPage";
import Cursor from "./components/Cursor";
import Particles from './components/Particles';

function App() {

    return (
        <div
            style={{
                minHeight: '100vh',
                backgroundSize: 'cover',
                backgroundRepeat: 'no-repeat',
                backgroundPosition: 'center',
                backgroundImage: `url(${process.env.PUBLIC_URL}/bg1.png)`,
            }}
        >
            <Router>
                <Particles
                    particleColors={['#ffffff', '#ffffff']}
                    particleCount={350}
                    particleSpread={20}
                    speed={0.014}
                    particleBaseSize={55}
                    moveParticlesOnHover={false}
                    alphaParticles={true}
                    disableRotation={false}
                />
                <Cursor />
                <div style={{ position: "relative", zIndex: 10 }}>
                    <Navbar />
                    <div className="flex-grow-1">
                        <Routes>
                            <Route path="/" element={ <LandingPage/> } />
                            <Route path="/about" element={ <AboutPage/> } />
                            <Route path="/projects" element={ <ProjectsPage/> } />
                            <Route path="/contact" element={ <ContactPage/> } />
                            <Route path="*" element={ <NotFoundPage /> } />
                        </Routes>
                    </div>
                </div>
            </Router>
        </div>
    );

}

export default App;
